import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Fade,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API, graphqlOperation } from "aws-amplify";
import { checkItemUsed } from "../../../graphql/queries";
import { purchasePriceObj, sellingPriceObj } from "./ItemListData";
import "../Components/Invoice.css";
import moment from "moment";
import {
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../../../components/snackBar/snakbar";
import CancelPriceMdal from "./CancelPriceMdal";
import Loader from "../Components/Loader";
import NewUpdatePriceTable from "./NewUpdatePriceTable";
import { getItemmaster } from "../../../graphql";
import { useListPriceTypesQuery } from "../../../redux/apis/pricetype.api";
import useSaveShortcut from "../../../hooks/useSaveShortcut";
import useSaveModalShortcut from "../Components/useSaveModalShortcut";
const style = {
  position: "absolute",
  right: "10%",
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: "0px",
  // overflow: "auto",
  // height: "85%",
  width: "90%",
  top: "50%",
  left: "50%",
  height: 600,
  transform: "translate(-50%,-50% )",
  outline: "none",
};
function PriceModal({
  open,
  setOpen,
  data,
  todayDate,
  sellingPriceRows,
  setSellingPriceRows,
  editedSellingPriceRows,
  setEditedSellingPriceRows,
  tempSellingPriceRows,
  setTempSellingPriceRows,
  purchasePriceRows,
  setPurchasePriceRows,
  editedPurchasePriceRows,
  setEditedPurchasePriceRows,
  tempPurchasePriceRows,
  setTempPurchasePriceRows,
  setData,
  params,
  setParams,
  setRegistrationType,
  registrationType,
  getCompany,
  activeRow,
  setActiveRow,
  priceTypeArr,
  setPriceTypeArr,
  priceTypeID,
  setPriceTypeID,
  setDeletedSalesRows,
  setDeletedPurchaseRows,
  previousID,
  setPreviousID,
  taxableValue

}) {
  
      const {
        data: priceList,
        isLoading: isGroupLoading,
        isError,
      } = useListPriceTypesQuery();
  let companyData = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
    
    
  
      const companyType = companyData?.relatedcompanydetailsnew?.[0]?.registrationtype;
         const isCessFlag=getCompany?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag;
     const userPreferenceAndFY = useSelector(
        (state) => state.userPrefrenceandReducer
      );
      const fyStartDate = moment(
        userPreferenceAndFY.financialYear?.startdate * 1000
      ).format("YYYY-MM-DD");

  const DiscountType = [
    { label: "%", value: 1 },
    { label: "₹", value: 2 },
  ];
  const CessTypes = [
    { label: "Percentage", value: 1 },
    { label: "Amount", value: 2 },
  ];
  const PriceTypes = [
    { label: "Wholesale", value: 1 },
    { label: "Retail", value: 2 },
  ];
  const AllGSTRates=[
    {id:-1,rate:'NIL'},
    { id: 0, rate: "0%" },
    { id: 1, rate: "1%" },
    { id: 2, rate: "2%" },
    { id: 3, rate: "3%" },
    { id: 5, rate: "5%" },
    { id: 6, rate: "6%" },
    { id: 12, rate: "12%" },
    { id: 18, rate: "18%" },
    { id: 28, rate: "28%" },
  ]
  const GStRates =
    companyData?.relatedcompanydetailsnew?.[0].registrationtype === 3
      ? [
          { id: 1, rate: "1%" },
          { id: 2, rate: "2%" },
          { id: 3, rate: "3%" },
          { id: 5, rate: "5%" },
          { id: 6, rate: "6%" },
        ]
      : [
          { id: 0, rate: "0%" },
          { id: 3, rate: "3%" },
          { id: 5, rate: "5%" },
          { id: 12, rate: "12%" },
          { id: 18, rate: "18%" },
          { id: 28, rate: "28%" },
        ];
  const newSalesObj = {
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
     priceType: { label: '', value: 0,tabletype:0 },
    isActive: 0,
    effectivefrom: "",
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  };
  const newPurchaseObj = {
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: '', value: 0,tabletype:0 },
    isActive: 0,
    effectivefrom: "",
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  };
  const newActiveSalesObj = {
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
     priceType: { label: '', value: 0,tabletype:0 },
    isActive: 1,
    effectivefrom: "",
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  };
  const newActivePurchaseObj = {
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
     priceType: { label: '', value: 0,tabletype:0 },
    isActive: 1,
    effectivefrom: "",
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  };
  const [purchaseIndex, setPurchaseIndex] = useState("");
  const [salesIndex, setSalesIndex] = useState("");
  const [purchaseNewFlag, setPurchaseNewFlag] = useState(true);
  const [salesNewFlag, setSalesNewFlag] = useState(true);
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [salesEntryIndex, setSalesEntryIndex] = useState("");
  const [deletePurchaseEntriesModal, setDeletePurchaseEntriesModal] =
    useState(false);
  const [deleteSalesEntriesModal, setDeleteSalesEntriesModal] = useState(false);
  const [isFocusPurchase, setIsFocusPurchase] = useState(false);
  const [isFocusSales, setIsFocusSales] = useState(false);
  const [isFocusSalesRow, setIsFocusSalesRow] = useState(false);
  const [isFocusPurchaseRow, setIsFocusPurchaseRow] = useState(false);
  const [editSalesFlag, setEditSalesFlag] = useState(false);
  const [editPurchaseFlag, setEditPurchaseFlag] = useState(false);
  const [isPurchaseValid, setPurchaseValid] = useState(true);
  const [isSalesValid, setSalesValid] = useState(true);
  const [isSalesDuplicate, setIsSalesDuplicate] = useState(false);
  const [isPurchaseDuplicate, setIsPurchaseDuplicate] = useState(false);
  const [isSalesActive, setIsSalesActive] = useState(0);
  const [isPurchaseActive, setIsPurchaseActive] = useState(0);
  const [amountSalesExcGst, setAmtSalesExcGst] = useState(0);
  const [amountSalesIncGst, setAmtSalesIncGst] = useState(0);
  const [amountPurchaseExcGst, setAmtPurchaseExcGst] = useState(0);
  const [amountPurchaseIncGst, setAmtPurchaseIncGst] = useState(0);
  const [purchaseEntryIndex, setPurchaseEntryIndex] = useState("");
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [salesEffectiveToFlag, setSalesEffectiveToFlag] = useState(false);
  const [purchaseEffectiveToFlag, setPurchaseEffectiveToFlag] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [itemUsed, setItemUsed] = useState(false);
  const [checkSalesPriceType, setCheckSalesPriceType] = useState(false);
  const [checkPurchasePriceType, setCheckPurchasePriceType] = useState(false);
  const [tableErrArr, setTableErrArr] = useState([]);

  function handleClose() {
    if (activeRow === true && params?.view === false) {
      setOpenCancel(true);
    } else {
      setOpen(false);
    }
  }


  async function saveChanges() {
    let isvalid = true;
    let errorArr = [];
    let salesAmt = 0;
    let purchaseAmt = 0;
    let requireds = [];
    let salesTaxableAmt=0;
    let purchaseTaxableAmt=0;
    const hasNonEmptyPriceType = sellingPriceRows.some(
      (item) => item?.priceType?.label && item.priceType?.label?.trim() !== ""
    );
    setCheckSalesPriceType(hasNonEmptyPriceType);
    if (sellingPriceRows.length > 0) {
      sellingPriceRows.filter((ele, index) => {
        if (ele?.priceType?.label !== "" || ele?.amount !== 0) {
          if (ele?.priceType?.label === "") {
            requireds.push("Price Type");
            errorArr.push(sellingPriceObj?.priceType + `${index}`);
            setSalesValid(false);
            isvalid = false;
          }
          if (ele?.amount == 0 || ele?.amount === "") {
            requireds.push("Rate");
            errorArr.push(sellingPriceObj?.amount + `${index}`);
            setSalesValid(false);
            isvalid = false;
          }
          if (
            registrationType !== 1 &&
            (data?.taxability?.value === 1 || data?.taxability?.value === 4 || data?.taxability?.value === "")
          ) {
            
            if (ele?.gstRate?.id === "") {
              requireds.push("GST Rate");
              errorArr.push(sellingPriceObj?.gstRate + `${index}`);
              setSalesValid(false);
              isvalid = false;
            }

          }
          if (ele?.effectivefrom === '') {
                            requireds.push('Effective From');
                            errorArr.push(sellingPriceObj?.effectivefrom + `${index}`);
                            setSalesValid(false);
                            isvalid = false;
                          }
        }
        if(isvalid){
                      const currentFromDate = moment(ele.effectivefrom, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
                      const currentToDate = moment(ele.effectiveto, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
              
                      if (
                        ele.effectiveto &&
                        ele.effectiveto !== 0 &&
                        currentFromDate.isValid() &&
                        currentToDate.isValid() &&
                        !currentFromDate.isBefore(currentToDate) &&
                        !currentFromDate.isSame(currentToDate, "day")
                      ) {
                        isvalid=false
                        showWarningSnackbar("Effective From date must be earlier than Effective To date.");
                        setSalesValid(false);
                        errorArr.push(sellingPriceObj?.effectivefrom + `${index}`);
                        let element=sellingPriceObj?.effectivefrom + `${index}`;
                        const prevElement = document.getElementById(element);
                        prevElement?.focus();
                      
                      }
                      
                      if (
                        ele.effectiveto &&
                        ele.effectiveto !== 0 &&
                        currentFromDate.isValid() &&
                        currentToDate.isValid() &&
                        currentFromDate.isAfter(currentToDate) 
                      ) {
                        isvalid=false
                        showWarningSnackbar("Effective To date must be later than Effective from date.");
                        errorArr.push(sellingPriceObj?.effectiveto + `${index}`);
                        setSalesValid(false);
                        let element=sellingPriceObj?.effectiveto + `${index}`;
                        const prevElement = document.getElementById(element);
                        prevElement?.focus();
                      
                      }
                    }
        return isvalid;
      });
    }
    if (purchasePriceRows.length > 0) {
      purchasePriceRows.filter((ele, index) => {
      if (ele?.priceType?.label !== "" || ele?.amount !== 0) {
          if (ele?.priceType?.label === "") {
            requireds.push("Price Type");
            errorArr.push(purchasePriceObj?.priceType + `${index}`);
            setPurchaseValid(false);
            isvalid = false;
          }
          if (ele?.amount == 0 || ele?.amount === "") {
            requireds.push("Rate");
            errorArr.push(purchasePriceObj?.amount + `${index}`);
            setPurchaseValid(false);
            isvalid = false;
          }
          if (
            registrationType !== 1 &&
            (data?.taxability?.value === 1 || data?.taxability?.value === 4|| data?.taxability?.value === "")
          ) {
            if (ele?.gstRate?.id === "") {
              requireds.push("GST Rate");
              errorArr.push(purchasePriceObj?.gstRate + `${index}`);
              setPurchaseValid(false);
              isvalid = false;
            }
          }
          if (ele?.effectivefrom === '') {
                            requireds.push('Effective From');
                            errorArr.push(purchasePriceObj?.effectivefrom + `${index}`);
                            setPurchaseValid(false);
                            isvalid = false;
                          }
        }
        if(isvalid){
                      const currentFromDate = moment(ele.effectivefrom, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
                      const currentToDate = moment(ele.effectiveto, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
              
                      if (
                        ele.effectiveto &&
                        ele.effectiveto !== 0 &&
                        currentFromDate.isValid() &&
                        currentToDate.isValid() &&
                        !currentFromDate.isBefore(currentToDate) &&
                        !currentFromDate.isSame(currentToDate, "day")
                      ) {
                        isvalid=false
                        showWarningSnackbar("Effective From date must be earlier than Effective To date.");
                        errorArr.push(purchasePriceObj?.effectivefrom + `${index}`);
                        setPurchaseValid(false);
                        let element=purchasePriceObj?.effectivefrom + `${index}`;
                        const prevElement = document.getElementById(element);
                        prevElement?.focus();
                      
                      }
                      
                      if (
                        ele.effectiveto &&
                        ele.effectiveto !== 0 &&
                        currentFromDate.isValid() &&
                        currentToDate.isValid() &&
                        currentFromDate.isAfter(currentToDate) 
                      ) {
                        isvalid=false
                        showWarningSnackbar("Effective To date must be later than Effective from date.");
                        setPurchaseValid(false);
                        errorArr.push(purchasePriceObj?.effectiveto + `${index}`);
                        let element=purchasePriceObj?.effectiveto + `${index}`;
                        const prevElement = document.getElementById(element);
                        prevElement?.focus();
                      
                      }
                    }
        return isvalid;
      });
    }
    requireds = [...new Set(requireds)];
  
    if (isvalid) {
      if (sellingPriceRows?.length > 0) {
        sellingPriceRows.map((ele) => {
          if (ele.isActive === 1) {
            salesAmt =companyType===3?ele?.amtaftdicount: ele.amountIncludingGst;
            salesTaxableAmt=ele.amtaftdicount
          }
        });
      }
      
      if (purchasePriceRows?.length > 0) {
        purchasePriceRows.map((ele) => {
          if (ele.isActive === 1) {
            purchaseAmt = ele.amountIncludingGst;
            purchaseTaxableAmt=ele.amtaftdicount
          }
        });
      }
      setData((prev) => ({
        ...prev,
        sellingprice: salesAmt,
        purchaseAmt: purchaseAmt,
        purchaseTaxableAmt:purchaseTaxableAmt,
        salesTaxableAmt:salesTaxableAmt


      }));
      setParams({ id: "", view: false, salesFlag: 0, purchaseFlag: 0 });
      showSuccessSnackbar("Price updated");
      isvalid = true;
      setOpen(false);
    } else {
      setOpen(true);

      if (requireds.length > 1) {
        showWarningSnackbar(` ${requireds}` + " " + " " + "are required");
      }
      if (requireds.length === 1) {
        showWarningSnackbar(` ${requireds}` + " " + " " + "is required");
      }
      setTableErrArr(errorArr);
    }
  }
  async function getItemData(Id) {
    try {
      setSalesNewFlag(false);
      setPurchaseNewFlag(false);
      setBackdropOpen(true);
      let salesObj = {};
      let purchaseObj = {};
      let salesArr = [];
      let purchaseArr = [];
      let gstRate = { label: "", value: "" };
      let totPurchaseAmt = 0;
      let totpurchaseCess = 0;
      let gstPurchaseAmt = 0;
      let discountPurchaseAmt = 0;
      let totSalesAmt = 0;
      let totSalesCess = 0;
      let gstSalesAmt = 0;
      let discountSalesAmt = 0;
      let salesAfterDiscount = 0;
      let purchaseAfterDiscount = 0;
      let salesIsActive = 0;
      let purchaseIsActive = 0;
      let priceTypeObj = { label: "", value: 0 ,tabletype:0};
      const res = await API.graphql(
        graphqlOperation(getItemmaster, { itemid: Id })
      );
      if (res.data.getItemmaster !== null) {
        setPreviousID(res.data.getItemmaster?.[0]?.itemid);
        res.data.getItemmaster?.[0]?.relateditemamountdetails.map((itemEle) => {
          if (itemEle.amount != 0) {
            AllGSTRates.map((rate) => {
              if (rate.id === itemEle.gstrate) {
                gstRate = { rate: rate.rate, id: rate?.id };
              }
            });
            if (priceTypeID === "") {
              if (itemEle?.pricetype !== "") {
               
                    priceTypeObj = { label: itemEle?.pricetype, value: itemEle?.pricetypeid ,tabletype:itemEle?.pricetypeid};
                 
              } else {
                priceTypeObj = { label: "", value: 0 ,tabletype:0};
              }
            }

            if (itemEle.invoicetype === 1 && params?.salesFlag == 1) {
              salesIsActive = itemEle?.isdefault;
              discountSalesAmt =
                itemEle.discounttype == 1
                  ? (Number(itemEle?.amount) * Number(itemEle.discountvalue)) /
                    100
                  : Number(itemEle.discountvalue);
              salesAfterDiscount =
                Number(itemEle?.amount) - Number(discountSalesAmt);
              if (res?.data?.getItemmaster?.[0]?.taxabilitycd == 4 ) {
                totSalesCess = 0;
                gstSalesAmt = 0;
              } else {
                if(isCessFlag===0){
                  totSalesCess=0;
                }else{
                totSalesCess =
                  itemEle.gstcompensationtype == 1
                    ? (Number(salesAfterDiscount) *
                        Number(itemEle?.gstcompensationvalue)) /
                      100
                    : Number(itemEle?.gstcompensationvalue);
                }
                gstSalesAmt =
                  (Number(salesAfterDiscount) * Number(itemEle?.gstrate)) / 100;
                     gstSalesAmt =Number(gstSalesAmt)>0?gstSalesAmt:0;
              }
              totSalesAmt =
                registrationType === 1
                  ? Number(itemEle?.amount) - Number(discountSalesAmt)
                  : Number(itemEle?.amount) -
                    Number(discountSalesAmt) +
                    Number(gstSalesAmt) +
                    Number(totSalesCess);

              salesObj = {
                id: itemEle?.id,
                amount: itemEle.amount,
                DiscountType: itemEle.discounttype,
                DiscountValue: itemEle.discountvalue,
                gstRate: gstRate,
                effectivefrom: moment
                  .unix(itemEle.effectivedate)
                  .format("YYYY-MM-DD"),
                effectiveto:
                  itemEle.expireddate !== 0
                    ? moment.unix(itemEle.expireddate).format("YYYY-MM-DD")
                    : "",
                cesstype: itemEle.gstcompensationtype == 1 ? 1 : 2,
                cess: itemEle.gstcompensationvalue,
                amtaftdicount: salesAfterDiscount,
                discountAmt: discountSalesAmt,
                amountIncludingGst:companyType===3?Number(salesAfterDiscount):
                  // Number(itemEle.Amount) -
                  // Number(itemEle.DiscountValue) +
                  // Number(itemEle.GSTCompensationValue),
                  Number(totSalesAmt),
                new: false,
                invoiceType: 1,
                activeType: itemEle.isactive,
                isActive: itemEle.isdefault,
                // priceType: itemEle.PriceType,
                priceType: priceTypeObj,
                itemID: itemEle?.itemid,
                expiredtimestamp: itemEle?.expiredtimestamp,
              };
              salesArr.push(salesObj);
            }
            if (itemEle.invoicetype === 2 && params?.purchaseFlag == 1) {
              purchaseIsActive = itemEle?.isdefault;
              discountPurchaseAmt =
                itemEle.discounttype == 1
                  ? (Number(itemEle?.amount) * Number(itemEle.discountvalue)) /
                    100
                  : Number(itemEle.discountvalue);
              purchaseAfterDiscount =
                Number(itemEle?.amount) - Number(discountPurchaseAmt);
                if (registrationType == 1) {
                  gstPurchaseAmt=0;
              totpurchaseCess =0;

                }else{
                  if(isCessFlag===0){
                    totpurchaseCess=0;
                  }else{
              totpurchaseCess =
                itemEle.gstcompensationtype == 1
                  ? (Number(purchaseAfterDiscount) *
                      Number(itemEle?.gstcompensationvalue)) /
                    100
                  : Number(itemEle?.gstcompensationvalue);
                  }
              gstPurchaseAmt =
                (Number(purchaseAfterDiscount) * Number(itemEle?.gstrate)) /
                100;
                 gstPurchaseAmt =
                Number(gstPurchaseAmt)>0?gstPurchaseAmt:0;
                }
                
              totPurchaseAmt =
                registrationType === 1
                  ? Number(itemEle?.amount) - Number(discountPurchaseAmt)
                  : Number(itemEle?.amount) -
                    Number(discountPurchaseAmt) +
                    Number(gstPurchaseAmt) +
                    Number(totpurchaseCess);
              purchaseObj = {
                id: itemEle?.id,
                itemID: itemEle?.itemid,
                amount: itemEle.amount,
                DiscountType: itemEle.discounttype,
                DiscountValue: itemEle.discountvalue,
                gstRate: gstRate,
                effectivefrom: moment
                  .unix(itemEle.effectivedate)
                  .format("YYYY-MM-DD"),
                effectiveto:
                  itemEle.expireddate !== 0
                    ? moment.unix(itemEle.expireddate).format("YYYY-MM-DD")
                    : "",
                cesstype: itemEle.gstcompensationtype == 1 ? 1 : 2,
                cess: itemEle.gstcompensationvalue,
                amtaftdicount: purchaseAfterDiscount,
                discountAmt: discountPurchaseAmt,
                amountIncludingGst:
                  // Number(itemEle.Amount) -
                  // Number(itemEle.DiscountValue) +
                  // Number(itemEle.GSTCompensationValue),
                  Number(totPurchaseAmt),
                new: false,
                invoiceType: 2,
                activeType: itemEle.isactive,
                isActive: itemEle.isdefault,
                // priceType: itemEle.pricetype,
                priceType: priceTypeObj,
                expiredtimestamp: itemEle?.expiredtimestamp,
              };
              purchaseArr.push(purchaseObj);
              
            }
          }
        });

        setIsPurchaseActive(purchaseIsActive);
        setIsSalesActive(salesIsActive);
        if (salesArr?.length > 0) {
          setSellingPriceRows(salesArr);
        } else {
          setSellingPriceRows([newActiveSalesObj]);
        }
        if (purchaseArr?.length > 0) {
          setPurchasePriceRows(purchaseArr);
        } else {
          setPurchasePriceRows([newActivePurchaseObj]);
        }
      }
      setBackdropOpen(false);
    } catch (error) {
      setBackdropOpen(false);
      console.log("error", error);
    }
  }
  function resetPurchasTable() {
    setPurchasePriceRows([
      {
        id: 0,
        expiredtimestamp: 0,
        amount: 0,
        DiscountType: 1,
        DiscountValue: 0,
        gstRate: { rate: " ", id: "" },
        cesstype: 1,
        cess: 0,
        amtaftdicount: 0,
        discountAmt: 0,
        priceType: { label: "", value: "",tabletype:0 },
        isActive: 1,
        effectivefrom: "",
        effectiveto: "",
        amountIncludingGst: 0,
        timeStamp: false,
        editable: true,
        new: true,
        order: 1,
        activeType: 1,
        invoiceType: 2,
      },
    ]);
    setPurchaseValid(true);
  }
  function resetSalesTable() {
    setSellingPriceRows([
      {
        id: 0,
        expiredtimestamp: 0,
        amount: 0,
        DiscountType: 1,
        DiscountValue: 0,
        gstRate: { rate: " ", id: "" },
        cesstype: 1,
        cess: 0,
        amtaftdicount: 0,
        discountAmt: 0,
        priceType: { label: "", value: "" ,tabletype:0},
        isActive: 1,
        effectivefrom: "",
        effectiveto: "",
        amountIncludingGst: 0,
        timeStamp: false,
        editable: true,
        new: true,
        order: 1,
        activeType: 1,
        invoiceType: 1,
      },
    ]);
    setSalesValid(true);
  }
  useEffect(() => {  
    if (params?.id && params?.id !== previousID) {
      // checkItemUsedInInvoice(params?.id);
      getItemData(params?.id);
    }
  }, [open, params, priceTypeArr]);
  async function checkItemUsedInInvoice(itemID) {
    try {
      const res = await API.graphql(
        graphqlOperation(checkItemUsed, { ItemID: itemID })
      );
      if (res.data.checkItemUsed?.[0]?.StatusCode === "Error") {
        setItemUsed(true);
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  useEffect(() => {
    let elements = document.getElementsByName(tableErrArr[0]);
    setTimeout(() => {
      if (elements.length > 0) {
        const element = elements[0];
        if (element.tabIndex === -1) {
          element.setAttribute("tabindex", "0");
        }

        element.focus();
      }
    }, 0);
  }, [tableErrArr]);
  
  const ids = [
    'CreatePriceType',
  ];
  const anyElementExists = () => ids.some((id) => document.getElementById(id) !== null);
  useSaveModalShortcut(()=>{
    if(open===true && !anyElementExists()){
      saveChanges();
    }
  })
  return (
    <Box id={open?"PriceModal":""}>
    <Modal
      sx={{ width: "200px 200px" }}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              // height: "auto",
              flexGrow: 1,
              flexShrink: 1,
              alignItems: "stretch",
              justifyContent: "flex-start",
              height:"70vh"
            }}
          >
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  flex: 1,
                  backgroundColor: "inherit",
                  zIndex: 1000,
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    position: "sticky",
                    top: 0,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {params?.id !== "" && params?.view === false
                    ? "Update Price"
                    : params?.id !== "" && params?.view === true
                    ? "View Price"
                    : "Add Price"}
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <Close sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>
            <Box
              className="custom-scrollbar"
              sx={{
                height: "60vh",
                overflow: "auto",
              }}
            >
              {/* {(data.salesInvoiceFlag === 1 || params?.salesFlag === 1) && ( */}
              <Box
                className="custom-scrollbar"
              
              //  className={
              //   data?.salesAccount?.value === ""
              //     ? "disable-interactions !important"
              //     : "none !important"
              // }
              
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "background.paper",
                  marginBottom: "10px",
                  pointerEvents: data?.salesAccount?.value === "" || params?.view === true
                  ? "none !important"
                  : "auto",
                
                  boxShadow:
                    "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
                  padding: { xs: "10px 0px", sm: "10px 10px" },

                  ":hover": {
                    boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
                  },
                  transition: "all 1s ease-in-out",
                }}
              >
                <NewUpdatePriceTable
                  Type=""
                  tableType="Sales"
                  rows={sellingPriceRows}
                  tempRow={tempSellingPriceRows}
                  editedRow={editedSellingPriceRows}
                  setRows={setSellingPriceRows}
                  setEditedRow={setEditedSellingPriceRows}
                  setTempRow={setTempSellingPriceRows}
                  data={data}
                  companyData={companyData}
                  registrationType={registrationType}
                  endDate={endDate}
                  startDate={startDate}
                  setNewItemRowStatus={setSalesNewFlag}
                  newItemRowStatus={salesNewFlag}
                  setIsFocusItem={setIsFocusSales}
                  isFocusItem={isFocusSales}
                  rowIndex={salesIndex}
                  setRowIndex={setSalesIndex}
                  deleteEntriesModal={deleteSalesEntriesModal}
                  setDeleteEntriesModal={setDeleteSalesEntriesModal}
                  entryIndex={salesEntryIndex}
                  setEntryIndex={setSalesEntryIndex}
                  todayDate={todayDate}
                  setRegistrationType={setRegistrationType}
                  effectiveToFlag={salesEffectiveToFlag}
                  setEffectiveToFlag={setSalesEffectiveToFlag}
                  setAmtExcGst={setAmtSalesExcGst}
                  setAmtIncGst={setAmtSalesIncGst}
                  amountExcGst={amountSalesExcGst}
                  amountIncGst={amountSalesIncGst}
                  setBackdropOpen={setBackdropOpen}
                  GStRates={GStRates}
                  CessTypes={CessTypes}
                  DiscountType={DiscountType}
                  taxableValue={taxableValue}
                  editFlag={editSalesFlag}
                  setEditFlag={setEditSalesFlag}
                  isFocusRow={isFocusSalesRow}
                  setIsFocusRow={setIsFocusSalesRow}
                  isValid={isSalesValid}
                  setIsValid={setSalesValid}
                  isDuplicate={isSalesDuplicate}
                  setIsDuplicate={setIsSalesDuplicate}
                  isActive={isSalesActive}
                  setIsActive={setIsSalesActive}
                  setActiveRow={setActiveRow}
                  params={params}
                  itemUsed={itemUsed}
                  activeFlag={data.salesInvoiceFlag || params?.salesFlag}
                  priceTypeArr={priceTypeArr.filter(p => p.tabletype === 1)}
                  setPriceTypeArr={setPriceTypeArr}
                  priceTypeID={priceTypeID}
                  setPriceTypeID={setPriceTypeID}
                  emptyPriceType={checkSalesPriceType}
                  setEmptyPriceType={setCheckSalesPriceType}
                  nameObj={sellingPriceObj}
                  newArr={newSalesObj}
                  newActiveArr={newActiveSalesObj}
                  setTableErrArr={setTableErrArr}
                  sellingPriceRows={sellingPriceRows}
                  purchasePriceRows={purchasePriceRows}
                  purchasePriceObj={purchasePriceObj}
                  sellingPriceObj={sellingPriceObj}
                  setDeletedRows={setDeletedSalesRows}
                />
              </Box>
              {/* // )} */}
              {/* {(data.purchaseInvoiceFlag === 1 || params?.purchaseFlag === 1) && ( */}
              <Box
                // className={
                //   data?.purchseAccount?.value === "" || params?.view === true
                //     ? "disable-interactions !important"
                //     : "none !important"
                // }
                  className="custom-scrollbar"
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "background.paper",
                  marginBottom: "10px",
                  boxShadow:
                    "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
                  padding: { xs: "10px 0px", sm: "10px 10px" },

                  ":hover": {
                    boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
                  },
                  transition: "all 1s ease-in-out",
                }}
              >
                <NewUpdatePriceTable
                  Type=""
                  tableType="Purchase"
                  rows={purchasePriceRows}
                  tempRow={tempPurchasePriceRows}
                  editedRow={editedPurchasePriceRows}
                  effectiveToFlag={purchaseEffectiveToFlag}
                  setEffectiveToFlag={setPurchaseEffectiveToFlag}
                  setRows={setPurchasePriceRows}
                  setEditedRow={setEditedPurchasePriceRows}
                  setTempRow={setTempPurchasePriceRows}
                  data={data}
                  endDate={endDate}
                  startDate={startDate}
                  setNewItemRowStatus={setPurchaseNewFlag}
                  newItemRowStatus={purchaseNewFlag}
                  setIsFocusItem={setIsFocusPurchase}
                  isFocusItem={isFocusPurchase}
                  rowIndex={purchaseIndex}
                  setRowIndex={setPurchaseIndex}
                  deleteEntriesModal={deletePurchaseEntriesModal}
                  setDeleteEntriesModal={setDeletePurchaseEntriesModal}
                  entryIndex={purchaseEntryIndex}
                  setEntryIndex={setPurchaseEntryIndex}
                  todayDate={todayDate}
                  registrationType={registrationType}
                  setRegistrationType={setRegistrationType}
                  setAmtExcGst={setAmtPurchaseExcGst}
                  setAmtIncGst={setAmtPurchaseIncGst}
                  amountExcGst={amountPurchaseExcGst}
                  amountIncGst={amountPurchaseIncGst}
                  setBackdropOpen={setBackdropOpen}
                  companyData={companyData}
                  GStRates={GStRates}
                  CessTypes={CessTypes}
                  DiscountType={DiscountType}
                  taxableValue={taxableValue}
                  editFlag={editPurchaseFlag}
                  setEditFlag={setEditPurchaseFlag}
                  isFocusRow={isFocusPurchaseRow}
                  setIsFocusRow={setIsFocusPurchaseRow}
                  isValid={isPurchaseValid}
                  setIsValid={setPurchaseValid}
                  PriceTypes={PriceTypes}
                  isDuplicate={isPurchaseDuplicate}
                  setIsDuplicate={setIsPurchaseDuplicate}
                  isActive={isPurchaseActive}
                  setIsActive={setIsPurchaseActive}
                  params={params}
                  getCompany={getCompany}
                  setActiveRow={setActiveRow}
                  itemUsed={itemUsed}
                  activeFlag={data.purchaseInvoiceFlag || params?.purchaseFlag}
                  priceTypeArr={priceTypeArr.filter(p => p.tabletype === 2)}
                  setPriceTypeArr={setPriceTypeArr}
                  priceTypeID={priceTypeID}
                  setPriceTypeID={setPriceTypeID}
                  emptyPriceType={checkPurchasePriceType}
                  setEmptyPriceType={setCheckPurchasePriceType}
                  nameObj={purchasePriceObj}
                  newArr={newPurchaseObj}
                  newActiveArr={newActivePurchaseObj}
                  setTableErrArr={setTableErrArr}
                  sellingPriceRows={sellingPriceRows}
                  purchasePriceRows={purchasePriceRows}
                  purchasePriceObj={purchasePriceObj}
                  sellingPriceObj={sellingPriceObj}
                  setDeletedRows={setDeletedPurchaseRows}
                />
              </Box>
              {params?.view === false && (
              <Box
              sx={{
                borderRadius: "8px",
                marginBottom: "10px",
                padding: { xs: "10px 0px", sm: "10px 10px" },
                transition: "all 1s ease-in-out",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center", 
                position: "sticky",
                bottom: 0,
                backgroundColor: "#fff",
                zIndex:1
              }}
            >
              <Button
                variant="contained"
                sx={{ marginRight: "8px" }}
                onClick={saveChanges}
              >
                Apply
              </Button>
              <Button onClick={handleClose} variant="outlined">
                Cancel
              </Button>
            </Box>
            
            
            )}
            </Box>
            {/* // )} */}
           
          </Box>
          <CancelPriceMdal
            open={openCancel}
            setOpen={setOpenCancel}
            sellingPriceRows={sellingPriceRows}
            purchasePriceRows={purchasePriceRows}
            setSellingPriceRows={setSellingPriceRows}
            setPurchasePriceRows={setPurchasePriceRows}
            closePriceModal={setOpen}
            getItemData={(Id) => getItemData(Id)}
            params={params}
            resetPurchasTable={() => resetPurchasTable()}
            resetSalesTable={() => resetSalesTable()}
            setData={setData}
          />
          <Loader open={backdropOpen} />
        </Box>
      </Fade>
    </Modal>
    </Box>
  );
}

export default PriceModal;
